import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import { RELEASE_SCHEDULE } from "../config";

export interface NextRelease {
  target: DateTime;
  localZone: string;
  days: number;
  hours: number;
  minutes: number;
}

const computeNextRelease = (): NextRelease => {
  const now = DateTime.local();
  let target = now.set({
    weekday: RELEASE_SCHEDULE.weekday as 1,
    hour: RELEASE_SCHEDULE.hour,
    minute: RELEASE_SCHEDULE.minute,
    second: 0,
    millisecond: 0,
  });

  if (target <= now) target = target.plus({ weeks: 1 });

  const diff = target.diff(now, ["days", "hours", "minutes"]).toObject();

  return {
    target,
    localZone: now.zoneName ?? "",
    days: Math.max(0, Math.floor(diff.days ?? 0)),
    hours: Math.max(0, Math.floor(diff.hours ?? 0)),
    minutes: Math.max(0, Math.floor(diff.minutes ?? 0)),
  };
};

export const useNextRelease = (): NextRelease => {
  const [next, setNext] = useState<NextRelease>(computeNextRelease);

  useEffect(() => {
    const interval = setInterval(() => setNext(computeNextRelease()), 30000);
    return () => clearInterval(interval);
  }, []);

  return next;
};
